export const BEDROCK_OPENAI_PROVIDER_PREFIX = "bedrock-openai";

export const BEDROCK_OPENAI_GPT_5_6_SOL_MODEL_ID = "openai.gpt-5.6-sol";
export const BEDROCK_OPENAI_GPT_5_5_MODEL_ID = "openai.gpt-5.5";
export const BEDROCK_OPENAI_GPT_5_4_MODEL_ID = "openai.gpt-5.4";

export const BEDROCK_OPENAI_GPT_5_6_SOL_MODEL_REF =
  "bedrock-openai/openai.gpt-5.6-sol";
export const BEDROCK_OPENAI_GPT_5_5_MODEL_REF = "bedrock-openai/openai.gpt-5.5";
export const BEDROCK_OPENAI_GPT_5_4_MODEL_REF = "bedrock-openai/openai.gpt-5.4";

export type BedrockOpenAIModelRef =
  | typeof BEDROCK_OPENAI_GPT_5_6_SOL_MODEL_REF
  | typeof BEDROCK_OPENAI_GPT_5_5_MODEL_REF
  | typeof BEDROCK_OPENAI_GPT_5_4_MODEL_REF;

export function isBedrockOpenAIModelRef(
  modelRef: string | null | undefined,
): modelRef is BedrockOpenAIModelRef {
  return (
    modelRef === BEDROCK_OPENAI_GPT_5_6_SOL_MODEL_REF ||
    modelRef === BEDROCK_OPENAI_GPT_5_5_MODEL_REF ||
    modelRef === BEDROCK_OPENAI_GPT_5_4_MODEL_REF
  );
}
